/**
 * SuggestionChips — the 2-3 stage-appropriate next actions the assistant
 * suggests each turn. Clicking a chip sends it as a chat message.
 */

import React from 'react';
import { cn } from '@/lib/utils';

export interface SuggestionChipsProps {
  suggestions: string[];
  onPick: (text: string) => void;
  disabled?: boolean;
  className?: string;
}

export const SuggestionChips: React.FC<SuggestionChipsProps> = ({
  suggestions,
  onPick,
  disabled,
  className,
}) => {
  if (suggestions.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {suggestions.map((chip) => (
        <button
          key={chip}
          type="button"
          disabled={disabled}
          onClick={() => onPick(chip)}
          className={cn(
            'min-h-[36px] rounded-full bg-inset px-3 text-[13px] font-semibold text-navy-ink',
            'hover:bg-line-2 transition-colors',
            disabled && 'opacity-50 cursor-not-allowed',
          )}
        >
          {chip}
        </button>
      ))}
    </div>
  );
};
